<template>
  <div class="kpi-tile" :title="hint || ''">
    <span class="kpi-tile__icon">
      <feather-icon :icon="icon" size="18" />
    </span>
    <div class="kpi-tile__body">
      <div class="kpi-tile__value">{{ value }}</div>
      <div class="kpi-tile__label">{{ label }}</div>
    </div>
  </div>
</template>

<script>
// One number on a report page. The icon colour comes from the --accent and
// --accent-soft CSS variables of whatever wraps it, so a page section sets
// its colour once and every tile inside follows.
export default {
  name: 'KpiTile',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: 0 },
    icon: { type: String, required: true },
    hint: { type: String, default: '' },
  },
}
</script>

<style scoped>
.kpi-tile {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  height: 100%;
  padding: 0.9rem 1rem;
  border: 1px solid #ebe9f1;
  border-radius: 0.45rem;
  background: #fafafc;
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}
.kpi-tile:hover {
  box-shadow: 0 4px 14px rgba(34, 41, 47, 0.08);
  transform: translateY(-1px);
}
.kpi-tile__icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 0.45rem;
  background: var(--accent-soft, rgba(115, 103, 240, 0.12));
  color: var(--accent, #7367f0);
}
.kpi-tile__body { min-width: 0; }
.kpi-tile__value {
  font-size: 1.45rem;
  font-weight: 700;
  line-height: 1.2;
  color: #5e5873;
}
.kpi-tile__label {
  font-size: 0.8rem;
  color: #6e6b7b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Vuexy's dark skin puts .dark-layout on <body>. */
.dark-layout .kpi-tile { background: #161d31; border-color: #3b4253; }
.dark-layout .kpi-tile__value { color: #d0d2d6; }
.dark-layout .kpi-tile__label { color: #b4b7bd; }
</style>
